export default "__VITE_ASSET__BTq060oM__"